import React from 'react'

interface ISafeAreaProviderProps {
  children: React.ReactNode
}

export const SafeAreaProvider: React.FC<ISafeAreaProviderProps> = ({ children }) => <>{children}</>
